const HTTP_HEADER = Object.freeze({
  mt: 'Authorization',
  lt: 'LOCK_TOKEN',
  ct: 'Content-Type',
});

// noinspection JSUnusedGlobalSymbols
export default HTTP_HEADER;
